import React, { useEffect, useState, useRef, memo } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

// ─── MARQUEE CSS ─────────────────────────────────────────────────────────────
const MARQUEE_CSS = `
@keyframes lookbook-marquee {
  0%   { transform: translate3d(0, 0, 0); }
  100% { transform: translate3d(-50%, 0, 0); }
}
.lb-marquee-track {
  display: flex;
  width: max-content;
  animation: lookbook-marquee 180s linear infinite;
  will-change: transform;
  -webkit-transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.lb-marquee-wrap:hover .lb-marquee-track {
  animation-play-state: paused;
}
`;

// ─── ASSET REGISTRY ──────────────────────────────────────────────────────────
const V = {
  vault1:       'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/900e83dfb975cb28b656aa0968a4457b.mov',
  vsl1:         'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/520b7dd497bd8f17457763457032b939.mov',
  tiffloop:     'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/95530c91dbffc6c3c967a97f9e34e027.mov',
  echo1:        'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/217f675a492af5ba54ab4f6aeda291eb.mov',
  kelly1:       'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/bdec17e80fccd1e86f13a1098f584e7f.mov',
  echo2:        'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/428fff1a42001f225e86464b93b9d343.mov',
  nova1:        'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/9bdcdab02d2b0907787e1f77c778e0bf.mov',
  azita:        'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/ef2c4958151430faa4e76874daf93a23.mov',
  natty:        'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/04080691f08fd5b7d76036c5e0b6d7ec.mov',
  luxe1:        'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vbXA0/e917a7a1f1b3e53157754d819648bd5a.mp4',
  looplux:      'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/23d5ab55ac287f418b61a7e7c0777519.mov',
  interviewlop: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/05c20469eb9d7900bf8404da1dd40aa8.mov',
  sc_intro:     'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vbXA0/c3382b092292c6cb9ecd6f08fba61cd4.mp4',
  sc_food1:     'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vbXA0/1dc878d5ef6027d6895ad4cf2d004962.mp4',
  sc_food2:     'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vbXA0/a1cbb65e81274d01e207b22761338aae.mp4',
  sc_ai_loses:  'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vbXA0/55c8cd2d9571e42de6802a1aed602c7c.mp4',
  sc_perfection: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vbXA0/69a221ff9c4b432839720faca954e4c6.mp4',
  sc_talented:  'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vbXA0/a03c86b5c82e73e43b23528c95a2a98f.mp4',
  ol_timeline_vid: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/823fd46511ee80485faa07ba27cddb78.mov',
  ol_roy_vid:   'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/ba98355d036ae973b96193b46218dd36.mov',
  ol_customer_loop: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/a5e87214f23febc2c9fc1d4a1d8ffdf0.mov',
  ol_firechat:  'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/5c97917896df8872c6396c8c66e9ebda.mov',
};

const P = {
  vault1:       'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2Uvd2VicA==/34d2ea00f9857bd86bb74153c0d48f40.webp',
  vault2:       'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvcG5n/327342bc5001060c1a1b2e47f9a8323b.png',
  vault3:       'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2Uvd2VicA==/74bec9e0b20a218892079ee2b1036c76.webp',
  echo1:        'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvanBlZw==/2b6127be4855d400bae43a70b2c61e1f.jpg',
  kelly2:       'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2Uvd2VicA==/e05f315e740880642ab9e5910eeeca71.webp',
  nova1:        'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2Uvd2VicA==/eb855d3a16028d6551d2925d044cd1c7.webp',
  nova2:        'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2Uvd2VicA==/4196a3e2f41d1baedf2e7e87f0d87309.webp',
  luxe1:        'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvanBlZw==/b157a458a787e2df8fa6558ea731bfc6.jpg',
  luxe2:        'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2Uvd2VicA==/599553c5da67abd10229fee08be1c150.webp',
  ol_new_photo1: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvcG5n/3dea94118a1b68409a87840049176785.png',
  ol_new_photo2: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvcG5n/6e71c43f2ceb94409efab64c1b27648b.png',
  ol_new_photo3: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvcG5n/c78776c698417896abb1019c9d7d53f6.png',
  ol_new_photo4: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvcG5n/12cc862689362edfa1232e97e094e513.png',
};

// ─── SETS DATA ────────────────────────────────────────────────────────────────
const SETS = [
  {
    id: 'vault', number: '01', name: 'VAULT',
    capacity: '1 Person', use: 'Solo Podcasts, VSLs & Executive Messages',
    assets: [
      { type: 'video', src: V.vault1,   alt: 'Vault Set ambient loop' },
      { type: 'photo', src: P.vault1,   alt: 'Vault Set empty still' },
      { type: 'video', src: V.vsl1,     alt: 'Vault VSL session loop' },
      { type: 'photo', src: P.vault2,   alt: 'Vault talent still' },
      { type: 'video', src: V.tiffloop, alt: 'Vault talent loop' },
      { type: 'photo', src: P.vault3,   alt: 'Vault Set detail still' },
    ],
  },
  {
    id: 'echo', number: '02', name: 'ECHO',
    capacity: '2 Guests', use: '1-on-1 Interviews & Co-Hosted Shows',
    assets: [
      { type: 'video', src: V.echo1,  alt: 'Echo Set ambient loop' },
      { type: 'photo', src: P.echo1,  alt: 'Echo Set empty still' },
      { type: 'video', src: V.kelly1, alt: 'Echo talent loop' },
      { type: 'photo', src: P.kelly2, alt: 'Echo talent still' },
      { type: 'video', src: V.echo2,  alt: 'Echo second session loop' },
    ],
  },
  {
    id: 'nova', number: '03', name: 'NOVA',
    capacity: '2 Guests', use: '1-on-1 Interviews & Co-Hosted Shows',
    assets: [
      { type: 'video', src: V.nova1, alt: 'Nova Set ambient loop' },
      { type: 'photo', src: P.nova1, alt: 'Nova Set empty still' },
      { type: 'video', src: V.azita, alt: 'Nova Azita talent loop' },
      { type: 'photo', src: P.nova2, alt: 'Nova talent still' },
      { type: 'video', src: V.natty, alt: 'Nova Natty talent loop' },
    ],
  },
  {
    id: 'luxe', number: '04', name: 'LUXE',
    capacity: 'Up to 4 Guests', use: 'Panel Discussions & Group Podcasts',
    assets: [
      { type: 'video', src: V.luxe1,        alt: 'Luxe Set ambient loop' },
      { type: 'photo', src: P.luxe1,        alt: 'Luxe Set empty still' },
      { type: 'video', src: V.looplux,      alt: 'Luxe talent loop' },
      { type: 'photo', src: P.luxe2,        alt: 'Luxe talent still' },
      { type: 'video', src: V.interviewlop, alt: 'Luxe interview loop' },
    ],
  },
];

// ─── SOCIAL CUTS ──────────────────────────────────────────────────────────────
const SOCIAL_CUTS = [
  { src: V.sc_intro, label: '[ INTRO // CUT ]' },
  { src: V.sc_food1, label: '[ STORY // CUT ]' },
  { src: V.sc_food2, label: '[ DELIVERY // CUT ]' },
  { src: V.sc_ai_loses, label: '[ AI LOSES // CUT ]' },
  { src: V.sc_perfection, label: '[ PERFECTION // CUT ]' },
  { src: V.sc_talented, label: '[ TALENTED // CUT ]' },
];

// ─── ON-LOCATION DATA ─────────────────────────────────────────────────────────
const ON_LOCATION = [
  { type: 'video', src: V.ol_timeline_vid },
  { type: 'photo', src: P.ol_new_photo1 },
  { type: 'video', src: V.ol_roy_vid },
  { type: 'photo', src: P.ol_new_photo2 },
  { type: 'video', src: V.ol_customer_loop },
  { type: 'photo', src: P.ol_new_photo3 },
  { type: 'video', src: V.ol_firechat },
  { type: 'photo', src: P.ol_new_photo4 },
];

// ─── OPTIMIZED LAZY VIDEO COMPONENTS ──────────────────────────────────────────
const LazyVideo = memo(function LazyVideo({ src, autoPlay, className, ...props }) {
  const videoRef = useRef(null);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (!hasLoaded) setHasLoaded(true);
          if (autoPlay && videoRef.current) {
            videoRef.current.play().catch(() => {});
          }
        } else {
          if (autoPlay && videoRef.current) {
            videoRef.current.pause();
          }
        }
      },
      { rootMargin: '600px' }
    );

    const el = videoRef.current;
    if (el) observer.observe(el);
    return () => { if (el) observer.unobserve(el); };
  }, [autoPlay, hasLoaded]);

  return (
    <video
      ref={videoRef}
      src={hasLoaded ? src : undefined}
      className={className}
      autoPlay={autoPlay && hasLoaded}
      {...props}
    />
  );
});

function MainVideoPlayer({ src, alt }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          videoRef.current?.play().catch(() => {});
        } else {
          videoRef.current?.pause();
        }
      },
      { rootMargin: '200px' }
    );

    if (videoRef.current) observer.observe(videoRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <video
      ref={videoRef}
      src={src}
      muted loop playsInline autoPlay
      aria-label={alt}
      className="w-full h-full object-cover"
    />
  );
}

// ─── MAIN DISPLAY ─────────────────────────────────────────────────────────────
function MainDisplay({ asset }) {
  if (asset.type === 'video') {
    return <MainVideoPlayer key={asset.src} src={asset.src} alt={asset.alt} />;
  }
  return (
    <img
      key={asset.src}
      src={asset.src}
      alt={asset.alt}
      loading="lazy"
      className="w-full h-full object-cover"
    />
  );
}

// ─── THUMBNAIL ────────────────────────────────────────────────────────────────
function Thumb({ asset, active, onClick, index }) {
  return (
    <button
      onClick={onClick}
      aria-label={`Select asset ${index + 1}: ${asset.alt}`}
      className={`relative w-full overflow-hidden border-2 transition-all duration-150 cursor-pointer focus:outline-none ${
        active
          ? 'border-white opacity-100'
          : 'border-white/10 opacity-70 hover:opacity-100 hover:border-white/30'
      }`}
      style={{ aspectRatio: '16 / 9' }}
    >
      {asset.type === 'video' ? (
        <LazyVideo
          src={asset.src}
          muted playsInline preload="metadata"
          className="absolute inset-0 w-full h-full object-cover"
          tabIndex={-1}
        />
      ) : (
        <img
          src={asset.src}
          alt={asset.alt}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      )}
    </button>
  );
}

// ─── SET BLOCK ────────────────────────────────────────────────────────────────
function SetBlock({ set }) {
  const [activeIdx, setActiveIdx] = useState(0);

  return (
    <motion.div
      className="border-b border-white/10 pb-16 mb-16 last:border-b-0 last:mb-0 last:pb-0"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="mb-5">
        <h2 className="text-xl md:text-2xl font-black tracking-[0.18em] text-white uppercase mb-1.5">
          SET {set.number} // {set.name}
        </h2>
        <p className="text-[11px] font-mono tracking-[0.2em] text-zinc-400 uppercase">
          {set.capacity.toUpperCase()}&nbsp;&nbsp;•&nbsp;&nbsp;{set.use.toUpperCase()}&nbsp;&nbsp;•&nbsp;&nbsp;STUDIO OPERATOR: <span className="text-zinc-300">INCLUDED</span>
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-3">
        <div
          className="relative overflow-hidden bg-zinc-950 border border-white/10 lg:flex-1"
          style={{ aspectRatio: '16 / 9' }}
        >
          <MainDisplay asset={set.assets[activeIdx]} />
        </div>
        <div className="flex flex-row lg:flex-col gap-2 lg:w-[17%]">
          {set.assets.map((asset, i) => (
            <div key={i} className="flex-1 lg:flex-none">
              <Thumb
                asset={asset}
                active={activeIdx === i}
                onClick={() => setActiveIdx(i)}
                index={i}
              />
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
}

// ─── SOCIAL CUTS LIGHTBOX ────────────────────────────────────────────────────
function SocialModal({ src, onClose }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
      videoRef.current.play().catch(() => {});
    }
  }, [src]);

  return (
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center p-0"
      style={{ backgroundColor: 'rgba(0,0,0,0.92)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)' }}
      onClick={onClose}
    >
      <div
        className="relative flex flex-col"
        style={{ width: 'min(340px, 88vw)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-end mb-3">
          <button
            onClick={onClose}
            className="font-mono text-xs text-white/50 hover:text-white transition-colors px-2 py-1 border border-white/10 hover:border-white/30 leading-none"
            aria-label="Close"
          >
            [ × ]
          </button>
        </div>
        <div className="relative w-full aspect-[9/16] bg-black border border-white/10 overflow-hidden">
          <video
            ref={videoRef}
            src={src}
            muted loop playsInline autoPlay
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
}

// ─── MEDIA MODAL (FOR ON-LOCATION) ──────────────────────────────────────────
function MediaModal({ asset, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[999] flex flex-col items-center justify-center p-4 md:p-8"
      style={{ backgroundColor: 'rgba(0,0,0,0.95)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)' }}
      onClick={onClose}
    >
      <button
        className="fixed top-4 right-4 z-[1000] w-14 h-14 flex items-center justify-center bg-black/60 border border-white/20 text-white hover:text-neutral-300 hover:bg-black/80 transition-colors"
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        aria-label="Close lightbox"
      >
        <SafeIcon icon={FiIcons.FiX} className="text-3xl" />
      </button>
      <div className="relative flex flex-col items-center justify-center w-full" onClick={(e) => e.stopPropagation()}>
        {asset.type === 'video' ? (
          <video
            src={asset.src}
            autoPlay loop muted playsInline
            className="max-h-[80vh] max-w-[95vw] w-auto object-contain border border-neutral-800 shadow-2xl"
          />
        ) : (
          <img
            src={asset.src}
            alt="Media Preview"
            className="max-h-[80vh] max-w-[95vw] w-auto object-contain border border-neutral-800 shadow-2xl"
          />
        )}
      </div>
    </div>
  );
}

// ─── SECTION 2: SOCIAL CUTS ───────────────────────────────────────────────────
function SocialCutsSection() {
  const [modalSrc, setModalSrc] = useState(null);

  useEffect(() => {
    const id = 'lb-marquee-style';
    if (!document.getElementById(id)) {
      const tag = document.createElement('style');
      tag.id = id;
      tag.textContent = MARQUEE_CSS;
      document.head.appendChild(tag);
    }
  }, []);

  const baseSet = [...SOCIAL_CUTS, ...SOCIAL_CUTS, ...SOCIAL_CUTS, ...SOCIAL_CUTS, ...SOCIAL_CUTS];
  const doubled = [...baseSet, ...baseSet];

  return (
    <section className="border-t border-white/10 pt-16 pb-16 overflow-hidden">
      <div className="px-5 md:px-10 lg:px-16 mb-8">
        <h2 className="text-xl md:text-2xl font-black tracking-[0.18em] text-white uppercase">
          SOCIAL CUTS
        </h2>
      </div>

      <div className="lb-marquee-wrap w-full overflow-hidden">
        <div className="lb-marquee-track py-4">
          {doubled.map((clip, i) => (
            <button
              key={i}
              onClick={() => setModalSrc(clip.src)}
              className="relative flex-shrink-0 w-52 md:w-60 aspect-[9/16] bg-neutral-900 border border-white/10 overflow-hidden cursor-pointer group transition-transform duration-300 hover:scale-[1.04] hover:z-10 focus:outline-none"
              style={{ marginRight: '16px' }}
              aria-label={`Open social cut: ${clip.label}`}
            >
              <LazyVideo
                src={clip.src}
                muted loop playsInline autoPlay
                className="absolute inset-0 w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      </div>

      {modalSrc && (
        <SocialModal src={modalSrc} onClose={() => setModalSrc(null)} />
      )}
    </section>
  );
}

// ─── SECTION 3: ON-LOCATION ───────────────────────────────────────────────────
function OnLocationSection() {
  const [modalAsset, setModalAsset] = useState(null);

  return (
    <section className="border-t border-white/10 pt-16 pb-16 px-5 md:px-10 lg:px-16">
      <div className="mb-8">
        <h2 className="text-xl md:text-2xl font-black tracking-[0.18em] text-white uppercase">
          ON-LOCATION
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {ON_LOCATION.map((card, i) => (
          <motion.div
            key={i}
            onClick={() => setModalAsset(card)}
            className="relative overflow-hidden bg-zinc-950 border border-white/10 cursor-pointer group"
            style={{ aspectRatio: '16/9' }}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ duration: 0.5, delay: (i % 4) * 0.07, ease: [0.22, 1, 0.36, 1] }}
          >
            {card.type === 'video' ? (
              <LazyVideo
                src={card.src}
                muted loop playsInline autoPlay
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            ) : (
              <img
                src={card.src}
                alt="Location"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
            )}
          </motion.div>
        ))}
      </div>

      {modalAsset && (
        <MediaModal asset={modalAsset} onClose={() => setModalAsset(null)} />
      )}
    </section>
  );
}

// ─── FOOTER ACTION BAR ────────────────────────────────────────────────────────
function FooterActionBar() {
  return (
    <footer className="border-t border-white/10 px-5 md:px-10 lg:px-16 py-20 flex flex-col items-center justify-center text-center">
      <h2 className="text-xl md:text-2xl font-black tracking-[0.18em] text-white uppercase mb-8">
        WORK WITH US
      </h2>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full max-w-sm sm:max-w-none">
        <Link
          to="/studio-sessions#booking-engine"
          className="bg-white text-black text-xs md:text-sm font-bold uppercase tracking-wider px-8 py-4 w-full sm:w-auto text-center rounded-[2px] transition-all duration-150 ease-in-out active:scale-95 hover:bg-neutral-200"
        >
          BOOK STUDIO
        </Link>
        <Link
          to="/video-services#contact"
          className="bg-transparent border border-white text-white text-xs md:text-sm font-bold uppercase tracking-wider px-8 py-4 w-full sm:w-auto text-center rounded-[2px] transition-all duration-150 ease-in-out hover:bg-white hover:text-black"
        >
          START A PROJECT
        </Link>
      </div>
    </footer>
  );
}

// ─── PAGE ─────────────────────────────────────────────────────────────────────
export default function Lookbook() {
  useEffect(() => {
    const TITLE = 'Lookbook | Studio Sets & Video Production | Bay Area Podcast Studio';
    const DESC  = 'Explore our four production-ready studio sets, social media video cuts, and on-location work. Bay Area Podcast Studio, Fremont, CA.';
    const URL   = 'https://bayareapodcast.studio/lookbook';
    const IMAGE = 'https://bayareapodcast.studio/favicon.svg';

    // ── helpers ──────────────────────────────────────────────────────────────
    const setMeta = (attr, val, content) => {
      let el = document.querySelector(`meta[${attr}="${val}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, val);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
      el.setAttribute('data-page-meta', 'lookbook');
    };

    const setLink = (rel, href) => {
      let el = document.querySelector(`link[rel="${rel}"][data-page-meta="lookbook"]`);
      if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        el.setAttribute('data-page-meta', 'lookbook');
        document.head.appendChild(el);
      }
      el.setAttribute('href', href);
    };

    // ── title ─────────────────────────────────────────────────────────────────
    document.title = TITLE;

    // ── standard meta ─────────────────────────────────────────────────────────
    setMeta('name', 'description',       DESC);
    setMeta('name', 'robots',            'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');

    // ── Open Graph ────────────────────────────────────────────────────────────
    setMeta('property', 'og:type',        'website');
    setMeta('property', 'og:url',         URL);
    setMeta('property', 'og:title',       TITLE);
    setMeta('property', 'og:description', DESC);
    setMeta('property', 'og:image',       IMAGE);

    // ── Twitter Card ──────────────────────────────────────────────────────────
    setMeta('name', 'twitter:card',        'summary_large_image');
    setMeta('name', 'twitter:site',        '@bayareapodcasts');
    setMeta('name', 'twitter:title',       TITLE);
    setMeta('name', 'twitter:description', DESC);
    setMeta('name', 'twitter:image',       IMAGE);

    // ── canonical ─────────────────────────────────────────────────────────────
    setLink('canonical', URL);

    // ── cleanup ───────────────────────────────────────────────────────────────
    return () => {
      document.title = 'Bay Area Podcast Studio';
      document.querySelectorAll('[data-page-meta="lookbook"]').forEach(el => el.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      {/* ── HEADER ── */}
      <header className="fixed top-0 left-0 right-0 z-40 h-14 flex items-center px-6 md:px-10 border-b border-white/10 bg-black/90 backdrop-blur-sm">
        <Link
          to="/"
          className="flex items-center gap-3 hover:opacity-70 transition-opacity"
          aria-label="Back to Bay Area Podcast Studio home"
        >
          <span className="text-white font-black text-sm tracking-[0.2em] uppercase">BA</span>
          <span className="text-white/30 text-sm select-none">|</span>
          <span className="text-white font-black text-[11px] tracking-[0.18em] uppercase hidden sm:block">
            BAY AREA PODCAST STUDIO
          </span>
        </Link>
      </header>

      <main className="pt-14">
        {/* ── PAGE TITLE ── */}
        <div className="px-5 md:px-10 lg:px-16 pt-14 pb-12 md:pt-16 md:pb-14 border-b border-white/10 mb-14">
          <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white tracking-[-0.02em] uppercase leading-none mb-4">
            STUDIO SETS &amp; PRODUCTION
          </h1>
          <p className="text-[11px] font-mono tracking-[0.3em] text-zinc-400 uppercase">
            Bay Area Podcast Studio // Fremont, CA
          </p>
        </div>

        {/* ── SECTION 1: SETS ── */}
        <div className="px-5 md:px-10 lg:px-16 pb-16">
          {SETS.map((set) => (
            <SetBlock key={set.id} set={set} />
          ))}
        </div>

        {/* ── SECTION 2: SOCIAL CUTS ── */}
        <SocialCutsSection />

        {/* ── SECTION 3: ON-LOCATION ── */}
        <OnLocationSection />
      </main>

      {/* ── FOOTER ACTION BAR ── */}
      <FooterActionBar />
    </div>
  );
}